export default [

  { heading: "Admin" },
  {
    title: "Users",
    to: { name: "user" },
    icon: { icon: "mdi-account-group-outline" },
    disable: false,
  },
  {
    title: "Staffing",
    to: { name: "staffing" },
    icon: { icon: "mdi-account-clock-outline" },
    disable: false,
  },
  {
    title: "Booking List",
    to: { name: "bookinglist" },
    icon: { icon: "mdi-calendar-text-outline" },
    disable: false,
  },
  {
    title: "Events",
    to: { name: "events" },
    icon: { icon: "mdi-calendar-star" },
    disable: false,
  },
  {
    title: "Area Status",
    to: { name: "areastatus" },
    icon: { icon: "mdi-list-status" },
    disable: false,
  },
  {
    title: "Matrix Displays",
    to: { name: "matrixdisplay" },
    icon: { icon: "mdi-television" },
    disable: false,
  },
  {
    title: "Gift Vouchers",
    to: { name: "giftvouchers" },
    icon: { icon: "mdi-wallet-giftcard" },
    disable: false,
  },
  {
    title: "Discount Codes",
    to: { name: "discount-codes" },
    icon: { icon: "mdi-percent-box-outline" },
    disable: false,
  },
  {
    title: "Products",
    to: { name: "products" },
    icon: { icon: "mdi-food-outline" },
    disable: false,
  },
  {
    title: "POS cash",
    to: { name: "transactions" },
    icon: { icon: "mdi-cash-multiple" },
    disable: false,
  },
  {
    title: "Dockets",
    to: "dockets",
    icon: { icon: "mdi-cart" },
    disable: false,
  },
  {
    title: "Reports",
    to: { name: "reports" },
    icon: { icon: "mdi-chart-bar" },
    disable: false,
  },
  {
    title: "Access Control",
    to: { name: "accesscontrol" },
    icon: { icon: "mdi-door-sliding-lock" },
    disable: false,
  },
  {
    title: "FAQ",
    to: { name: "faqs-admin" },
    icon: { icon: "mdi-frequently-asked-questions" },
    disable: false,
  },

  { heading: "Setup" },
  {
    title: "Location",
    to: { name: "location" },
    icon: { icon: "mdi-map-marker-outline" },
    disable: false,
  },
  {
    title: "Activities",
    to: { name: "activities" },
    icon: { icon: "mdi-golf" },
    disable: false,
  },
  {
    title: "Areas",
    to: { name: "areas" },
    icon: { icon: "mdi-map-marker-circle" },
    disable: false,
  },
  {
    title: "Advertising",
    to: { name: "advertising" },
    icon: { icon: "mdi-image" },
    disable: false,
  },
  {
    title: "Memberships",
    to: { name: "memberships" },
    icon: { icon: "mdi-account-heart-outline" },
    disable: false,
  },
  {
    title: "Coupon Types",
    to: { name: "coupontypes" },
    icon: { icon: "mdi-ticket" },
    disable: false,
  },
  {
    title: "Roles & Permissions",
    to: { name: "roles" },
    disable: false,
    icon: { icon: "mdi-shield-account-outline" },
    // children: [
    //   { title: "Roles", to: null, disable: true },
    //   { title: "Permissions", to: null, disable: true },
    // ],
  },
  {
    title: "Email Templates",
    to: { name: "emailtemplates" },
    icon: { icon: "mdi-email-multiple-outline" },
    disable: false,
  },
  {
    title: "Settings",
    to: { name: "settings" },
    icon: { icon: "mdi-cog" },
    disable: false,
  },
];
